import { ref } from 'vue';
import { toggleFeatureFlagForSchool } from '@/api/school';
import { isMfaEnabled, featureFlagTypes } from '@/lib/feature-flag';

export function useMfaToggle(schoolId, adminsListRef) {
    const isMfaFeatureEnabled = ref(false);
    const isLoading = ref(false);
    const isInitialLoading = ref(false);

    const validateAllAdminsHavePhone = () => {
        const adminsWithoutPhone = adminsListRef.value.filter((admin) => {
            const phone = (admin.phoneNumber || '').replace(/\D/g, '');
            return phone.length < 10;
        });

        if (adminsWithoutPhone.length > 0) {
            return {
                isValid: false,
                count: adminsWithoutPhone.length,
                emails: adminsWithoutPhone.map((admin) => admin.email)
            };
        }
        return { isValid: true };
    };

    const fetchInitialMfaState = async () => {
        if (!schoolId.value) {
            console.error('School ID not available for MFA check.');
            return false;
        }
        isInitialLoading.value = true;
        try {
            isMfaFeatureEnabled.value = await isMfaEnabled(schoolId.value);
            return true;
        } catch (error) {
            console.error('Failed to fetch initial MFA state:', error);
            return false;
        } finally {
            isInitialLoading.value = false;
        }
    };

    const toggleMfaFeature = async (newValue) => {
        if (!schoolId.value) {
            console.error('MFA Toggle: Missing school ID.');
            return { success: false };
        }

        isLoading.value = true;

        try {
            await toggleFeatureFlagForSchool({
                payload: {
                    schoolId: schoolId.value,
                    featureFlagName: featureFlagTypes.mfaEnabled,
                    enabled: newValue
                }
            });
            isMfaFeatureEnabled.value = newValue;
            return { success: true };
        } catch (error) {
            console.error('Failed to toggle MFA feature flag:', error);
            isMfaFeatureEnabled.value = !newValue;
            return { success: false };
        } finally {
            isLoading.value = false;
        }
    };

    return {
        isMfaFeatureEnabled,
        isLoading,
        isInitialLoading,
        fetchInitialMfaState,
        toggleMfaFeature,
        validateAllAdminsHavePhone
    };
}
